<template>
    <el-dialog class="tpl-selections-dialog"
            title="请选择你要添加的画布" width="760px"
            :visible.sync="dialogVisible">
        <div class="tpl-list">
            <div :key="-1" class="tpl-item">
                <div class="tpl-body">
                   <div class="hover-bg"><span class="add-btn" @click="onAdd()">添加</span></div>
                   <div class="empty-tpl">空白画布</div>
                </div>
                <div class="tpl-footer">
                    <p class="tpl-name">空白画布</p>
                    <p class="tpl-size">默认高度500</p>
                </div>
            </div>
            <div v-for="(item, i) in dataList" :key="i" class="tpl-item">
                <div class="tpl-body">
                    <div class="hover-bg"><span class="add-btn" @click="onAdd(item)">添加</span></div>
                    <img :src="item.defaultUrl">
                </div>
                <div class="tpl-footer">
                    <p class="tpl-name" :title="item.name">{{item.name}}</p>
                    <p class="tpl-size">{{item.json.width}}x{{item.json.height}}</p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import util from '@/util';
    export default {
        components:{},
        props:{
            value: {
                type: Boolean, default:false
            },
            dataList: Array
        },
        data(){
            return {
            }
        },
        computed:{
            dialogVisible:{
                get(){
                    return this.value;
                },
                set(v){
                    this.$emit('input', v);
                }
            },
            getScale(){
                let dataList = this.dataList;
                if(dataList && dataList.length > 0){
                    let item = dataList[0].json;
                    let w = item.width;
                    let h = item.width;
                    return util.getScale(200, 250, w, h);
                } else {
                    return 1;
                }
            }
        },
        methods:{
            onAdd(item){
                this.$emit('onAdd', item);
                this.$emit('input', false);
                this.saveUserAction(this.getActionPage().name.key, this.getActionPage().add.key);
            },
            getActionPage(){
                return this.ActionType.templateGroup.editor;
            }
        }
    }
</script>
<style lang="scss">
    @import "./tpl-selections-dialog";
</style>